import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';

export default function Services() {
  const navigate = useNavigate();
  const { data: services, loading } = usePublicList('services');
  const sorted = [...services].sort((a, b) => a.order - b.order);
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Xidmətlər</h2>
        <p className="section-subtitle">Təqdim etdiyimiz peofessional xidmətlər</p>
        {loading ? <p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p> : (
          <div className="svc-grid">
            {sorted.map((s) => (
              <button key={s.id} className="svc-item" onClick={() => navigate(`/xidmetler/${s.id}`)}>
                {s.title}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
